import { useState, useEffect } from "react";

export function useImageDimensions(url: string | null) {
  const [width, setWidth] = useState(0);
  const [height, setHeight] = useState(0);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!url) return;

    let isMounted = true;
    const img = new Image();

    img.onload = () => {
      if (isMounted) {
        setWidth(img.naturalWidth);
        setHeight(img.naturalHeight);
      }
    };

    img.onerror = () => {
      if (isMounted) {
        setError("Failed to load image dimensions.");
      }
    };

    img.src = url;

    return () => {
      isMounted = false;
    };
  }, [url]);

  return { width, height, error, isReady: !!width && !!height };
}
